import { Box, Typography, Button, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  padding: "32px 40px",
  boxSizing: "border-box",
});

export const TitleRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "2px",
});

export const ModalTitle = styled(Typography)({
  fontFamily: '"Sora", sans-serif',
  fontSize: "20px",
  fontWeight: 700,
  color: colors.text.primary,
});

export const ModalSubtitle = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "13px",
  color: colors.text.secondary,
  marginBottom: "28px",
});

export const SectionDivider = styled(Box)({
  height: "1px",
  backgroundColor: colors.border.light,
  margin: "20px 0 16px",
});

export const SectionLabel = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: "0.08em",
  color: colors.text.secondary,
  textTransform: "uppercase",
  marginBottom: "16px",
});

export const InfoGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "20px 32px",
  marginBottom: "4px",
});

export const InfoItem = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const InfoItemFull = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  gridColumn: "1 / -1",
});

export const InfoLabel = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: colors.text.secondary,
});

export const InfoValue = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "15px",
  fontWeight: 600,
  color: colors.text.primary,
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "32px",
});

export const CloseButton = styled(Button)({
  minWidth: "100px",
  height: "44px",
  border: `1px solid ${colors.border.light}`,
  color: colors.text.primary,
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: colors.background.default,
    borderColor: colors.border.medium,
  },
});

export const EditButton = styled(Button)({
  minWidth: "130px",
  height: "44px",
  backgroundColor: colors.primary.main,
  color: colors.text.white,
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  fontWeight: 700,
  textTransform: "none",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primary.dark,
    boxShadow: "none",
  },
});
